import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { merge, Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../../auth/services/auth.service';
import { BusinessUnitModel } from '../../models/business-unit/business-unit.model';

@Directive({ selector: '[ifHasBusinessUnit]' })
export class IfHasBusinessUnit implements OnDestroy, OnInit {
    @Input() set ifHasBusinessUnit(value: boolean) {
        this.updateView(value);
    }

    private _hasView = false;
    private _previousValue: boolean;
    private businessUnitUpdated$: Observable<BusinessUnitModel>;
    private idTokenUpdated$: Observable<string>;
    private securityStampUpdated$: Observable<string>;
    private subscription: Subscription;
    private notificationsCount$: Observable<string>;

    constructor(
        private _viewContainer: ViewContainerRef,
        private _template: TemplateRef<Object>,
        private _authService: AuthService
    ) {
        // if the id token or business unit gets updated, we need to re-evaluate
        this.idTokenUpdated$ = _authService.idTokenUpdated;
        this.businessUnitUpdated$ = _authService.businessUnitUpdated;
        this.securityStampUpdated$ = _authService.securityStampUpdated;
        this.notificationsCount$ = _authService.notificationsCount;
    }

    ngOnInit() {
        this.subscription = merge(this.idTokenUpdated$, this.businessUnitUpdated$, this.securityStampUpdated$, this.notificationsCount$)
            .pipe(filter(() => this._previousValue !== undefined))
            .subscribe(() => this.updateView(this._previousValue));
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    protected updateView(value: boolean) {
        this._previousValue = value;
        const condition = value ?
            this._authService.hasBusinessUnitAccess && this._authService.hasSecurityStamp :
            !(this._authService.hasBusinessUnitAccess && this._authService.hasSecurityStamp);

        if (condition && !this._hasView) {
            this._hasView = true;
            this._viewContainer.createEmbeddedView(this._template);
        } else if (!condition && this._hasView) {
            this._hasView = false;
            this._viewContainer.clear();
        }
    }
}
